import styled from 'styled-components';
import React from 'react';
import ds from 'designsystem';
import PropTypes from 'prop-types';
import { media } from 'designsystem/index';

const TagContainer = styled.a`
    font-size: ${ds.fs('base')};
    font-family: ${ds.get('type.fontFamily.text')};
    font-weight: ${ds.get('type.fontWeight.bold')};
    background-color: ${ds.get('colors.brand.white')};
    color: ${ds.get('colors.brand.text')};
    border: none;
    cursor: pointer;    
    display: flex;
    align-items: center;
    text-decoration: none;
    white-space: nowrap;
    width: 50%;
    justify-content: center;
    height: ${ds.get('metrics.m')};
    
    ${media.tablet`
      height: ${ds.get('navSection.navHeight')};
    `}
            
    ${media.desktop`
      width: initial;
      justify-content: center;
      height: ${ds.get('navSection.navHeight')};
    `}
`;
const Tag = styled.div`
    margin: 0;
    
    ${media.desktop`
        padding: ${ds.get('metrics.s')};
    `}
`;
const TagASignIn = (props) => {
  const { href, text } = props;
  return (
    <TagContainer href={href}>
      <Tag>
        {text}
      </Tag>
    </TagContainer>);
};
TagASignIn.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string,
};
TagASignIn.defaultProps = {
  href: '',
  text: '',
};
export default TagASignIn;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/Buttons/TagASignIn.jsx